class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.form = this.querySelector('form'); // Add this line
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
    this.form.addEventListener('submit', this.handleFormSubmit.bind(this)); // Add this line
  }
handleFormSubmit(event) {
  event.preventDefault(); // This stops the form from submitting the traditional way
  const searchQuery = this.input.value.trim();
  if (searchQuery.toLowerCase().includes('summer')) {
    window.location.href = 'https://www.brand63.com/pages/summer-fashion-and-accessories-for-less';
    // Replace the above URL with the actual URL of your summer collection
  } else {
    this.form.submit(); // If the search term isn't 'summer', submit the form as usual
  }
}

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
 function redirectToSummerPage(query) {
  if (query.toLowerCase().includes('summer')) {
    window.location.href = 'https://www.brand63.com/pages/summer-fashion-and-accessories-for-less';
  }
}
     
    }
  }
}

customElements.define('search-form', SearchForm);
